<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <pb-body-base class="cart-overview">
      <template v-slot:default="props">
         <pb-body>
            <template slot="title">
               <b-row class="mt-7 mb-4">
                  <b-col class="text-center">
                     <h3>Settings</h3>
                     <hr/>
                  </b-col>
               </b-row>
            </template>
            <template slot="body">
               <b-container class="personal-settings">
                  <b-row>
                     <b-col lg="4">
                        <div class="bg-gray p-4">
                           <h4>PERSONAL DATA</h4>
                           <b-row>
                              <b-col>
                                 {{ user.firstName }} {{ user.lastName }} <br>
                                 {{ user.email }} <br>
                                 {{ user.companyName }}<br/>
                                 <span v-if="user.externalData">
                                                {{ user.externalData.company.companyName }}<br/>
                                                {{ user.externalData.company.street }}<br/>
                                                {{
                                       user.externalData.company.zipCode
                                    }} {{ user.externalData.company.city }}
                                            </span>
                                 <span v-else>
                                                There are is no B2B Data available yet.
                                            </span>
                              </b-col>
                           </b-row>
                        </div>
                        <b-row>
                           <b-col>
                              <b-button variant="primary" v-b-modal.changePasswordModal
                                        class="btn-block my-2">
                                 CHANGE PASSWORD
                              </b-button>
                           </b-col>
                        </b-row>
                     </b-col>
                     <b-col lg="4" v-if="user.externalAccountType === 'DIAMOND'">
                        <div class="bg-gray p-4"
                             v-bind:class="[{ busy: submitProcessing}, 'opacity-transition']">
                           <pb-spinner v-if="submitProcessing"></pb-spinner>
                           <h4>GENERAL SETTINGS</h4>
                           <b-row>
                              <b-col>
                                 <b-form-checkbox @change="updateUserSettings"
                                                  v-model="user.pricingInAllCurrencies"
                                                  name="check-button" switch>
                                    Display article prices in all currencies.
                                 </b-form-checkbox>
                              </b-col>
                           </b-row>
                           <b-row class="mt-1" v-if="canWrite('ORDER_SUB')">
                              <b-col>
                                 <b-form-checkbox @change="updateUserSettings"
                                                  v-model="user.dailyOrderSubscriptionService"
                                                  name="check-button" switch>
                                    E-Mail notification on delivery updates
                                 </b-form-checkbox>
                              </b-col>
                           </b-row>
                        </div>
                     </b-col>
                     <!--<b-col lg="4">-->
                     <!--<div class="bg-gray p-4">-->
                     <!--<h4>DELIVERY ADDRESSES</h4>-->
                     <!--<b-row>-->
                     <!--<b-col>-->
                     <!--{{user.firstName}} {{user.lastName}} <br>-->
                     <!--{{user.email}} <br>-->
                     <!--{{user.companyName}}-->
                     <!--</b-col>-->
                     <!--</b-row>-->
                     <!--</div>-->
                     <!--<b-row>-->
                     <!--<b-col>-->
                     <!--<b-button variant="primary" v-b-modal.changePasswordModal-->
                     <!--class="btn-block my-2">-->
                     <!--CHANGE PASSWORD-->
                     <!--</b-button>-->
                     <!--</b-col>-->
                     <!--</b-row>-->
                     <!--</b-col>-->
                  </b-row>

               </b-container>
               <pb-change-password id="changePasswordModal"/>
            </template>
         </pb-body>
      </template>
   </pb-body-base>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import ChangePassword from "./ChangePassword";
import UserApi from "../../../../../shared/_api/user";

export default {
   name: 'pb-personal',
   components: {
      'pb-change-password': ChangePassword
   },
   data() {
      return {
         submitProcessing: false,
      }
   },
   methods: {
      ...mapActions('account', ['refreshSessionData']),
      updateUserSettings() {
         this.submitProcessing = true;
         UserApi.updateCurrencySetting({
            pricingInAllCurrencies: this.user.pricingInAllCurrencies,
            dailyOrderSubscriptionService: this.user.dailyOrderSubscriptionService
         }).then(() => {
            return this.refreshSessionData();
         }).finally(() => {
            this.submitProcessing = false;
         });
      },
   },
   computed: {
      ...mapState("account", ['user']),
      ...mapGetters('account', ['canWrite'])
   }
};
</script>

<style lang="scss">

@import "~@shared/_assets/scss/constants";

.personal-settings {
   .nav-item a {
      font-size: 13px;
   }

   label {
      font-size: 15px;
   }
}
</style>